import { useCallback } from 'react'
import { Edit, SaveButton, SimpleForm, TextInput, Toolbar } from 'react-admin'
import { useForm, useFormState } from 'react-final-form'

const InvoiceEditButton = ({ handleSubmitWithRedirect, ...props }: any) => {
  const formState = useFormState()
  const form = useForm()

  const handleClick = useCallback(() => {
    if (!formState.values.internal_notes) {
      form.change('internal_notes', '')
    }
    handleSubmitWithRedirect(`/jobs/${formState.values.job}/show/invoices`)
  }, [form, formState, handleSubmitWithRedirect])

  return <SaveButton {...props} handleSubmitWithRedirect={handleClick} />
}

const InvoiceEditNotesToolbar = (props: any) => (
  <Toolbar {...props}>
    <InvoiceEditButton />
  </Toolbar>
)

const InvoiceEditNotes = (props: any) => {
  return (
    <Edit undoable={false} basePath="/invoices" resource="invoices" id={props.match.params.id} {...props}>
      <SimpleForm toolbar={<InvoiceEditNotesToolbar />}>
        <TextInput fullWidth multiline source="internal_notes" label="Internal Notes" />
      </SimpleForm>
    </Edit>
  )
}

export default InvoiceEditNotes
